import { IScoreEditorThis, TClef } from "../../../../../common/types";

export function handleAddNewVoice(this: IScoreEditorThis) {
  const score = { ...this.state.score };
  let next = [1, 2, 3, 4, 5].reduce((a, b) => (score["bars" + b] ? b : a), 0) + 1;
  let startBar = 0;
  if (score.bars[0] === null) startBar = 1;
  if (startBar === 1) {
      score["bars" + next] = [null, { notes: [] }];
  } else {
      score["bars" + next] = [{ notes: [] }];
  }
  score["clef" + next] = "treble" as TClef;
  this.setState({ score, activeVoice: next, selectedNote: null });
  return;
};
